import ViewInicjujForm from '../../components/views/rejestr/wp/inicjujProjekt/ViewInicjujForm.jsx'
import ViewListaElementyRejestru from '../../components/views/rejestr/wp/listaPozycjiRejestru/ViewListaElementyRejestru.jsx'

import { MAIN_REJESTR_API_LONG } from '../../components/utils/consts.js'
import ViewListaProfiliProjektu
    from "../../components/views/rejestr/wp/listaProfiliProjektu/ViewListaProfiliProjektu.jsx";
import ViewProjektForm from "../../components/views/rejestr/lib/components/projektForm/kp1/ViewProjektForm.jsx";
import ViewListaProcesuSprawozdania
    from "../../components/views/rejestr/wp/listaProcesuSprawozdania/ViewListaProcesuSprawozdania.jsx";

export const rejestrRoutes = [
    {
        path: `/wp/${MAIN_REJESTR_API_LONG}/inicjuj`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewInicjujForm />,
        mode: `pass`,
    },
    {
        path: `/wp/${MAIN_REJESTR_API_LONG}/:id/profile`,
        exact: true,
        roles: ['owner'],
        forbidden: true,
        view: <ViewListaProfiliProjektu/>,
        mode: `any`,
    },
    {
        path: `/wp/${MAIN_REJESTR_API_LONG}/karta/:tryb/:id`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewProjektForm />,
        mode: `pass`,
    },
    {
        path: `/wp/${MAIN_REJESTR_API_LONG}/:tryb/:id`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewInicjujForm />,
        mode: `pass`,
    },
    {
        path: `/wp/${MAIN_REJESTR_API_LONG}/lista`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewListaElementyRejestru />,
        mode: `pass`,
    },
    {
        path: `/wp/sprawozdanie/proces/lista/:rejestrId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewListaProcesuSprawozdania />,
        mode: `pass`,
    },
]
